// Traducciones para ConservacionEvidenciasPage
export const evidenceTranslations = {
  es: {
    'hero-title': 'Conservación de evidencias y validez a largo plazo',
    'hero-subtitle': 'La validez de un documento de transporte digital no termina en el momento de la firma. BlueCMR garantiza la conservación a largo plazo de los documentos y todas las evidencias electrónicas generadas durante su ciclo de vida.',
    'intro': 'Para que un documento pueda acreditar hechos, derechos y obligaciones en el tiempo, es imprescindible conservarlo de forma íntegra, accesible y verificable.',
    'obligations-title': 'Obligaciones de conservación en documentos de transporte',
    'obligations-intro': 'La normativa aplicable exige que los documentos de transporte puedan:',
    'preserve-legal': 'Conservarse durante plazos legales',
    'preserve-legal-desc': 'Mantenerse accesibles según normativa',
    'maintain-integrity': 'Mantenerse íntegros',
    'maintain-integrity-desc': 'Sin alteraciones ni modificaciones',
    'present-authorities': 'Presentarse ante autoridades',
    'present-authorities-desc': 'Cuando sea requerido',
    'allow-verification': 'Permitir verificación',
    'allow-verification-desc': 'Autenticidad y trazabilidad',
    'what-preserved-title': 'Qué se conserva en BlueCMR',
    'what-preserved-intro': 'BlueCMR no conserva únicamente el documento final, sino el conjunto completo de evidencias electrónicas que permiten reconstruir y probar los hechos asociados al transporte.',
    'documents-title': 'Documentos',
    'documents-transport': 'Documento de transporte en formato electrónico',
    'documents-versions': 'Versiones firmadas y cerradas',
    'documents-final': 'Documento final con firma PAdES y validación LTV',
    'evidence-title': 'Evidencias asociadas',
    'evidence-signature': 'Evidencias de firma electrónica (identidad, consentimiento, contexto)',
    'evidence-hash': 'Huellas criptográficas del documento',
    'evidence-events': 'Registros de eventos relevantes (creación, firma, modificaciones)',
    'evidence-timestamps': 'Sellos temporales y referencias de validación',
    'integrity-title': 'Integridad y no alteración',
    'integrity-intro': 'La conservación en BlueCMR se basa en principios de inmutabilidad verificable.',
    'integrity-immutable': 'Documento firmado inmutable',
    'integrity-immutable-desc': 'El documento firmado no puede modificarse sin invalidar las evidencias asociadas.',
    'integrity-detection': 'Detección de alteraciones',
    'integrity-detection-desc': 'Cualquier alteración posterior sería detectable mediante validaciones criptográficas.',
    'integrity-linking': 'Vinculación de evidencias',
    'integrity-linking-desc': 'Las evidencias se vinculan a una versión concreta del documento mediante huellas criptográficas.',
    'integrity-conclusion': 'Este enfoque garantiza que el documento conservado es exactamente el que fue firmado, incluso años después.',
    'ltv-title': 'Validez a largo plazo (LTV)',
    'ltv-intro': 'Los documentos firmados en BlueCMR incorporan mecanismos de validación a largo plazo (LTV), lo que permite:',
    'ltv-verify': 'Verificar tras expiración',
    'ltv-verify-desc': 'Incluso tras la expiración de certificados',
    'ltv-validity': 'Validez probatoria',
    'ltv-validity-desc': 'Mantener la validez en el tiempo',
    'ltv-independence': 'Independencia',
    'ltv-independence-desc': 'Reducir dependencias externas',
    'ltv-conclusion': 'El uso de sellado temporal y evidencias asociadas permite que el documento siga siendo verificable más allá del momento de su emisión.',
    'access-title': 'Acceso a documentos y evidencias',
    'access-parties-title': 'Acceso por las partes legitimadas',
    'access-parties-intro': 'Las partes intervinientes (cargador, transportista, destinatario u otros autorizados) pueden acceder a:',
    'access-document': 'El documento conservado',
    'access-status': 'Su estado',
    'access-evidence': 'Las evidencias asociadas',
    'access-controlled': 'El acceso está controlado y limitado conforme a los permisos y roles definidos.',
    'access-authorities-title': 'Acceso para autoridades e inspección',
    'access-authorities-intro': 'BlueCMR permite facilitar el acceso a los documentos de transporte y a sus evidencias cuando así lo requieran las autoridades competentes.',
    'access-authorities-how': 'Este acceso puede realizarse:',
    'access-immediate': 'De forma inmediata',
    'access-verifiable': 'De manera verificable',
    'access-no-modification': 'Sin necesidad de modificar el documento original',
    'access-relevant': 'Este aspecto es especialmente relevante en el marco del Documento de Control digital y de las inspecciones en carretera.',
    'portability-title': 'Portabilidad y exportación',
    'portability-intro': 'La conservación en BlueCMR no implica dependencia exclusiva de la plataforma.',
    'portability-can-title': 'Los documentos y evidencias pueden:',
    'portability-download': 'Descargarse',
    'portability-export': 'Exportarse',
    'portability-transfer': 'Transferirse a otros sistemas o repositorios',
    'portability-conclusion': 'Esto garantiza la portabilidad de la información y evita bloqueos tecnológicos, manteniendo la capacidad de prueba fuera de la plataforma si fuera necesario.',
    'secure-title': 'Conservación segura y disponibilidad',
    'secure-intro': 'Los documentos y evidencias se almacenan en infraestructuras diseñadas para garantizar:',
    'secure-availability': 'Alta disponibilidad',
    'secure-availability-desc': 'Acceso continuo a los documentos',
    'secure-durability': 'Durabilidad',
    'secure-durability-desc': 'Protección contra pérdida de datos',
    'secure-protection': 'Protección',
    'secure-protection-desc': 'Frente a pérdida o corrupción',
    'secure-conclusion': 'Este enfoque asegura que la información permanezca accesible durante los periodos de conservación exigidos.',
    'responsibilities-title': 'Alcance y responsabilidades',
    'responsibilities-bluecmr': 'Responsabilidad de BlueCMR',
    'responsibilities-bluecmr-1': 'Conservar los documentos y evidencias de forma íntegra y accesible',
    'responsibilities-bluecmr-2': 'Mantener la coherencia entre documento y evidencias',
    'responsibilities-bluecmr-3': 'Facilitar mecanismos de acceso y exportación',
    'responsibilities-parties': 'Responsabilidad de las partes',
    'responsibilities-parties-1': 'Definir y respetar los plazos de conservación aplicables',
    'responsibilities-parties-2': 'Gestionar el uso de los documentos conforme a la normativa vigente',
    'responsibilities-parties-3': 'Custodiar las copias exportadas fuera de la plataforma',
    'probative-title': 'Conservación como elemento probatorio',
    'probative-intro': 'La combinación de:',
    'probative-document': 'Documento electrónico',
    'probative-signature': 'Firma avanzada',
    'probative-evidence': 'Evidencias técnicas',
    'probative-timestamp': 'Sellado temporal',
    'probative-traceability': 'Trazabilidad completa',
    'probative-ltv': 'Validación LTV',
    'probative-conclusion': 'Permite que los documentos gestionados en BlueCMR puedan utilizarse como',
    'probative-conclusion-bold': 'prueba válida',
    'probative-conclusion-end': 'ante autoridades, auditorías y procedimientos legales, conforme a la normativa aplicable.',
    'cta-title': '¿Tienes dudas sobre la conservación de evidencias?',
    'cta-subtitle': 'Nuestro equipo puede resolver tus preguntas sobre conservación documental y validez legal',
    'cta-button': 'Contactar con el equipo',
    'documents': 'Documentos',
    'doc-electronic': 'Documento de transporte en formato electrónico',
    'doc-signed': 'Versiones firmadas y cerradas',
    'doc-final': 'Documento final con firma PAdES y validación LTV',
    'associated-evidence': 'Evidencias asociadas',
    'evidence-signature': 'Evidencias de firma electrónica (identidad, consentimiento, contexto)',
    'evidence-hash': 'Huellas criptográficas del documento',
    'evidence-events': 'Registros de eventos relevantes (creación, firma, modificaciones)',
    'evidence-timestamps': 'Sellos temporales y referencias de validación',
    'immutable-doc': 'Documento firmado inmutable',
    'immutable-doc-desc': 'El documento firmado no puede modificarse sin invalidar las evidencias asociadas.',
    'alteration-detection': 'Detección de alteraciones',
    'alteration-detection-desc': 'Cualquier alteración posterior sería detectable mediante validaciones criptográficas.',
    'evidence-linking': 'Vinculación de evidencias',
    'evidence-linking-desc': 'Las evidencias se vinculan a una versión concreta del documento mediante huellas criptográficas.',
    'integrity-conclusion': 'Este enfoque garantiza que el documento conservado es exactamente el que fue firmado, incluso años después.',
    'verify-after-expiration': 'Verificar tras expiración',
    'verify-after-expiration-desc': 'Incluso tras la expiración de certificados',
    'probative-validity': 'Validez probatoria',
    'probative-validity-desc': 'Mantener la validez en el tiempo',
    'independence': 'Independencia',
    'independence-desc': 'Reducir dependencias externas',
    'ltv-conclusion': 'El uso de sellado temporal y evidencias asociadas permite que el documento siga siendo verificable más allá del momento de su emisión.',
    'access-parties': 'Acceso por las partes legitimadas',
    'access-parties-intro': 'Las partes intervinientes (cargador, transportista, destinatario u otros autorizados) pueden acceder a:',
    'access-document': 'El documento conservado',
    'access-status': 'Su estado',
    'access-evidence': 'Las evidencias asociadas',
    'access-controlled': 'El acceso está controlado y limitado conforme a los permisos y roles definidos.',
    'access-authorities': 'Acceso para autoridades e inspección',
    'access-authorities-intro': 'BlueCMR permite facilitar el acceso a los documentos de transporte y a sus evidencias cuando así lo requieran las autoridades competentes.',
    'access-can-be': 'Este acceso puede realizarse:',
    'access-immediate': 'De forma inmediata',
    'access-verifiable': 'De manera verificable',
    'access-no-modification': 'Sin necesidad de modificar el documento original',
    'access-relevant': 'Este aspecto es especialmente relevante en el marco del Documento de Control digital y de las inspecciones en carretera.',
    'portability-can': 'Los documentos y evidencias pueden:',
    'portability-download': 'Descargarse',
    'portability-export': 'Exportarse',
    'portability-transfer': 'Transferirse a otros sistemas o repositorios',
    'portability-conclusion': 'Esto garantiza la portabilidad de la información y evita bloqueos tecnológicos, manteniendo la capacidad de prueba fuera de la plataforma si fuera necesario.',
    'secure-storage-title': 'Conservación segura y disponibilidad',
    'secure-storage-intro': 'Los documentos y evidencias se almacenan en infraestructuras diseñadas para garantizar:',
    'high-availability': 'Alta disponibilidad',
    'high-availability-desc': 'Acceso continuo a los documentos',
    'durability': 'Durabilidad',
    'durability-desc': 'Protección contra pérdida de datos',
    'protection': 'Protección',
    'protection-desc': 'Frente a pérdida o corrupción',
    'secure-storage-conclusion': 'Este enfoque asegura que la información permanezca accesible durante los periodos de conservación exigidos.',
    'scope-title': 'Alcance y responsabilidades',
    'bluecmr-responsibility': 'Responsabilidad de BlueCMR',
    'bluecmr-resp-1': 'Conservar los documentos y evidencias de forma íntegra y accesible',
    'bluecmr-resp-2': 'Mantener la coherencia entre documento y evidencias',
    'bluecmr-resp-3': 'Facilitar mecanismos de acceso y exportación',
    'parties-responsibility': 'Responsabilidad de las partes',
    'parties-resp-1': 'Definir y respetar los plazos de conservación aplicables',
    'parties-resp-2': 'Gestionar el uso de los documentos conforme a la normativa vigente',
    'parties-resp-3': 'Custodiar las copias exportadas fuera de la plataforma',
    'probative-intro': 'La combinación de:',
    'electronic-doc': 'Documento electrónico',
    'advanced-signature': 'Firma avanzada',
    'technical-evidence': 'Evidencias técnicas',
    'timestamp': 'Sellado temporal',
    'complete-traceability': 'Trazabilidad completa',
    'ltv-validation': 'Validación LTV',
    'probative-conclusion': 'Permite que los documentos gestionados en BlueCMR puedan utilizarse como prueba válida ante autoridades, auditorías y procedimientos legales, conforme a la normativa aplicable.'
  },
  en: {
    'hero-title': 'Evidence preservation and long-term validity',
    'hero-subtitle': 'The validity of a digital transport document does not end at the moment of signature. BlueCMR guarantees long-term preservation of documents and all electronic evidence generated during their lifecycle.',
    'intro': 'For a document to prove facts, rights and obligations over time, it is essential to preserve it in an integral, accessible and verifiable manner.',
    'obligations-title': 'Preservation obligations in transport documents',
    'obligations-intro': 'Applicable regulations require that transport documents can:',
    'preserve-legal': 'Be preserved for legal periods',
    'preserve-legal-desc': 'Remain accessible according to regulations',
    'maintain-integrity': 'Maintain integrity',
    'maintain-integrity-desc': 'Without alterations or modifications',
    'present-authorities': 'Be presented to authorities',
    'present-authorities-desc': 'When required',
    'allow-verification': 'Allow verification',
    'allow-verification-desc': 'Authenticity and traceability',
    'what-preserved-title': 'What is preserved in BlueCMR',
    'what-preserved-intro': 'BlueCMR does not only preserve the final document, but the complete set of electronic evidence that allows reconstructing and proving the facts associated with transport.',
    'documents-title': 'Documents',
    'documents-transport': 'Transport document in electronic format',
    'documents-versions': 'Signed and closed versions',
    'documents-final': 'Final document with PAdES signature and LTV validation',
    'evidence-title': 'Associated evidence',
    'evidence-signature': 'Electronic signature evidence (identity, consent, context)',
    'evidence-hash': 'Cryptographic fingerprints of document',
    'evidence-events': 'Records of relevant events (creation, signature, modifications)',
    'evidence-timestamps': 'Timestamps and validation references',
    'integrity-title': 'Integrity and non-alteration',
    'integrity-intro': 'Preservation in BlueCMR is based on principles of verifiable immutability.',
    'integrity-immutable': 'Immutable signed document',
    'integrity-immutable-desc': 'The signed document cannot be modified without invalidating associated evidence.',
    'integrity-detection': 'Alteration detection',
    'integrity-detection-desc': 'Any subsequent alteration would be detectable through cryptographic validations.',
    'integrity-linking': 'Evidence linking',
    'integrity-linking-desc': 'Evidence is linked to a specific version of the document through cryptographic fingerprints.',
    'integrity-conclusion': 'This approach ensures that the preserved document is exactly the one that was signed, even years later.',
    'ltv-title': 'Long-term validity (LTV)',
    'ltv-intro': 'Documents signed in BlueCMR incorporate long-term validation (LTV) mechanisms, which allow:',
    'ltv-verify': 'Verify after expiration',
    'ltv-verify-desc': 'Even after certificate expiration',
    'ltv-validity': 'Probative validity',
    'ltv-validity-desc': 'Maintain validity over time',
    'ltv-independence': 'Independence',
    'ltv-independence-desc': 'Reduce external dependencies',
    'ltv-conclusion': 'The use of timestamping and associated evidence allows the document to remain verifiable beyond the moment of its issuance.',
    'access-title': 'Access to documents and evidence',
    'access-parties-title': 'Access by legitimate parties',
    'access-parties-intro': 'Intervening parties (shipper, carrier, consignee or other authorized parties) can access:',
    'access-document': 'The preserved document',
    'access-status': 'Its status',
    'access-evidence': 'Associated evidence',
    'access-controlled': 'Access is controlled and limited according to defined permissions and roles.',
    'access-authorities-title': 'Access for authorities and inspection',
    'access-authorities-intro': 'BlueCMR allows facilitating access to transport documents and their evidence when required by competent authorities.',
    'access-authorities-how': 'This access can be performed:',
    'access-immediate': 'Immediately',
    'access-verifiable': 'In a verifiable manner',
    'access-no-modification': 'Without needing to modify the original document',
    'access-relevant': 'This aspect is especially relevant in the framework of the digital Control Document and roadside inspections.',
    'portability-title': 'Portability and export',
    'portability-intro': 'Preservation in BlueCMR does not imply exclusive dependence on the platform.',
    'portability-can-title': 'Documents and evidence can:',
    'portability-download': 'Be downloaded',
    'portability-export': 'Be exported',
    'portability-transfer': 'Be transferred to other systems or repositories',
    'portability-conclusion': 'This guarantees information portability and avoids technological lock-in, maintaining proof capability outside the platform if necessary.',
    'secure-title': 'Secure preservation and availability',
    'secure-intro': 'Documents and evidence are stored in infrastructures designed to guarantee:',
    'secure-availability': 'High availability',
    'secure-availability-desc': 'Continuous access to documents',
    'secure-durability': 'Durability',
    'secure-durability-desc': 'Protection against data loss',
    'secure-protection': 'Protection',
    'secure-protection-desc': 'Against loss or corruption',
    'secure-conclusion': 'This approach ensures that information remains accessible during required preservation periods.',
    'responsibilities-title': 'Scope and responsibilities',
    'responsibilities-bluecmr': 'BlueCMR responsibility',
    'responsibilities-bluecmr-1': 'Preserve documents and evidence in an integral and accessible manner',
    'responsibilities-bluecmr-2': 'Maintain coherence between document and evidence',
    'responsibilities-bluecmr-3': 'Facilitate access and export mechanisms',
    'responsibilities-parties': 'Parties responsibility',
    'responsibilities-parties-1': 'Define and respect applicable preservation periods',
    'responsibilities-parties-2': 'Manage document use according to current regulations',
    'responsibilities-parties-3': 'Safeguard exported copies outside the platform',
    'probative-title': 'Preservation as probative element',
    'probative-intro': 'The combination of:',
    'probative-document': 'Electronic document',
    'probative-signature': 'Advanced signature',
    'probative-evidence': 'Technical evidence',
    'probative-timestamp': 'Timestamping',
    'probative-traceability': 'Complete traceability',
    'probative-ltv': 'LTV validation',
    'probative-conclusion': 'Allows documents managed in BlueCMR to be used as',
    'probative-conclusion-bold': 'valid proof',
    'probative-conclusion-end': 'before authorities, audits and legal proceedings, in accordance with applicable regulations.',
    'cta-title': 'Do you have questions about evidence preservation?',
    'cta-subtitle': 'Our team can answer your questions about document preservation and legal validity',
    'cta-button': 'Contact the team',
    'documents': 'Documents',
    'doc-electronic': 'Transport document in electronic format',
    'doc-signed': 'Signed and closed versions',
    'doc-final': 'Final document with PAdES signature and LTV validation',
    'associated-evidence': 'Associated evidence',
    'evidence-signature': 'Electronic signature evidence (identity, consent, context)',
    'evidence-hash': 'Cryptographic fingerprints of document',
    'evidence-events': 'Records of relevant events (creation, signature, modifications)',
    'evidence-timestamps': 'Timestamps and validation references',
    'immutable-doc': 'Immutable signed document',
    'immutable-doc-desc': 'The signed document cannot be modified without invalidating associated evidence.',
    'alteration-detection': 'Alteration detection',
    'alteration-detection-desc': 'Any subsequent alteration would be detectable through cryptographic validations.',
    'evidence-linking': 'Evidence linking',
    'evidence-linking-desc': 'Evidence is linked to a specific version of the document through cryptographic fingerprints.',
    'integrity-conclusion': 'This approach ensures that the preserved document is exactly the one that was signed, even years later.',
    'verify-after-expiration': 'Verify after expiration',
    'verify-after-expiration-desc': 'Even after certificate expiration',
    'probative-validity': 'Probative validity',
    'probative-validity-desc': 'Maintain validity over time',
    'independence': 'Independence',
    'independence-desc': 'Reduce external dependencies',
    'ltv-conclusion': 'The use of timestamping and associated evidence allows the document to remain verifiable beyond the moment of its issuance.',
    'access-parties': 'Access by legitimate parties',
    'access-parties-intro': 'Intervening parties (shipper, carrier, consignee or other authorized parties) can access:',
    'access-document': 'The preserved document',
    'access-status': 'Its status',
    'access-evidence': 'Associated evidence',
    'access-controlled': 'Access is controlled and limited according to defined permissions and roles.',
    'access-authorities': 'Access for authorities and inspection',
    'access-authorities-intro': 'BlueCMR allows facilitating access to transport documents and their evidence when required by competent authorities.',
    'access-can-be': 'This access can be performed:',
    'access-immediate': 'Immediately',
    'access-verifiable': 'In a verifiable manner',
    'access-no-modification': 'Without needing to modify the original document',
    'access-relevant': 'This aspect is especially relevant in the framework of the digital Control Document and roadside inspections.',
    'portability-can': 'Documents and evidence can:',
    'portability-download': 'Be downloaded',
    'portability-export': 'Be exported',
    'portability-transfer': 'Be transferred to other systems or repositories',
    'portability-conclusion': 'This guarantees information portability and avoids technological lock-in, maintaining proof capability outside the platform if necessary.',
    'secure-storage-title': 'Secure preservation and availability',
    'secure-storage-intro': 'Documents and evidence are stored in infrastructures designed to guarantee:',
    'high-availability': 'High availability',
    'high-availability-desc': 'Continuous access to documents',
    'durability': 'Durability',
    'durability-desc': 'Protection against data loss',
    'protection': 'Protection',
    'protection-desc': 'Against loss or corruption',
    'secure-storage-conclusion': 'This approach ensures that information remains accessible during required preservation periods.',
    'scope-title': 'Scope and responsibilities',
    'bluecmr-responsibility': 'BlueCMR responsibility',
    'bluecmr-resp-1': 'Preserve documents and evidence in an integral and accessible manner',
    'bluecmr-resp-2': 'Maintain coherence between document and evidence',
    'bluecmr-resp-3': 'Facilitate access and export mechanisms',
    'parties-responsibility': 'Parties responsibility',
    'parties-resp-1': 'Define and respect applicable preservation periods',
    'parties-resp-2': 'Manage document use according to current regulations',
    'parties-resp-3': 'Safeguard exported copies outside the platform',
    'probative-intro': 'The combination of:',
    'electronic-doc': 'Electronic document',
    'advanced-signature': 'Advanced signature',
    'technical-evidence': 'Technical evidence',
    'timestamp': 'Timestamping',
    'complete-traceability': 'Complete traceability',
    'ltv-validation': 'LTV validation',
    'probative-conclusion': 'Allows documents managed in BlueCMR to be used as valid proof before authorities, audits and legal proceedings, in accordance with applicable regulations.'
  }
};
